import { z } from "zod";

const booleanCoerceSchema = z.preprocess((val) => {
  if (typeof val === "string") {
    if (val.toLowerCase() === "true") return true;
    if (val.toLowerCase() === "false") return false;
  }
  return val;
}, z.boolean());

export const envSchema = z.object({
  envName: z
    .enum(["production", "development", "test"])
    .optional()
    .default("development"),
  appEnv: z
    .enum(["production", "staging", "review", "ci", "local"])
    .optional()
    .default("production"),
  appName: z.coerce.string().optional().default("Supervizor"),
  api: z.object({
    url: z.coerce.string().optional().default("http://localhost:3000"),
    mock: booleanCoerceSchema.optional().default(false),
  }),
  datadog: z.object({
    applicationId: z.coerce.string().optional().default(""),
    clientToken: z.coerce.string().optional().default(""),
    site: z.coerce.string().optional().default("datadoghq.eu"),
    service: z.coerce.string().optional().default("supervizor-web"),
    envName: z.coerce.string().optional().default("development"),
  }),
  auth0: z.object({
    domain: z.coerce.string(),
    clientId: z.coerce.string(),
    audience: z.coerce.string(),
    callbackUrl: z.coerce
      .string()
      .optional()
      .default("http://localhost:5173/controls"),
    logoutTo: z.coerce.string(),
  }),
  i18n: z.object({
    translationLabelsBaseUrl: z.coerce
      .string()
      .optional()
      .default("https://labels.eu.supervizor.app"),
  }),
});

export type Env = z.infer<typeof envSchema>;

class EnvService {
  public readonly env: Env;

  constructor() {
    const env = {
      envName: import.meta.env.NODE_ENV,
      appEnv: import.meta.env.APP_ENV,
      appName: import.meta.env.VITE_APP_NAME,
      api: {
        url: import.meta.env.VITE_API_URL,
        mock: import.meta.env.VITE_API_MOCK,
      },
      datadog: {
        applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
        clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
        site: import.meta.env.VITE_DATADOG_SITE,
        service: import.meta.env.VITE_DATADOG_SERVICE,
        envName: import.meta.env.VITE_DATADOG_ENV,
      },
      auth0: {
        domain: import.meta.env.VITE_AUTH0_DOMAIN,
        clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
        callbackUrl: import.meta.env.VITE_AUTH0_CALLBACK_URL,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        logoutTo: import.meta.env.VITE_AUTH0_LOGOUT_TO,
      },
      i18n: {
        translationLabelsBaseUrl: import.meta.env
          .VITE_TRANSLATION_LABELS_BASE_URL,
      },
    };
    this.env = envSchema.parse(env);
  }
}
export default new EnvService();
